import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Button, Icon, Table, Tag, Tooltip } from "antd";

import { MakeModelInfoStatus, MakeModelInfoStatusText } from "../../../models";
import { getAdminMakeModelInfoList } from "./makeModelInfo.ducks";
import { IndexPagination } from "../../../components/IndexPagination";

import PageTitle from "../PageTitle";
import MakeModelInfoFilterForm from "./MakeModelInfoFilterForm";
import MakeModelInfoFormModal from "./MakeModelInfoFormModal";

import styles from "./manageMakeModelInfoPage.scss";

interface ManageMakeModelInfoPageProps {
  items: any[];
  page: number;
  itemPerPage: number;
  total: number;
  filters: any;
  getAdminMakeModelInfoList: (filters: any, page: number, itemPerPage: number, callback?: any) => void;
}

const ManageMakeModelInfoPage = (props: ManageMakeModelInfoPageProps) => {
  const { items, page, itemPerPage, total, filters, getAdminMakeModelInfoList } = props;

  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [editingStatus, setEditingStatus] = useState(null);

  const loadList = (nextFilters: any, nextPage: number) => {
    setLoading(true);
    getAdminMakeModelInfoList(nextFilters, nextPage, itemPerPage, () => setLoading(false));
  };

  useEffect(() => {
    loadList(filters, page);
  }, []);

  const handleSearch = (nextFilters: any) => {
    loadList(nextFilters, 1);
  };

  const handlePageChange = (nextPage: number) => {
    loadList(filters, nextPage);
  };

  const handleNew = () => {
    setEditingId(null);
    setModalVisible(true);
  };

  const handleEdit = (record: any) => {
    setEditingId(record.id);
    // BE's getById doesn't include the status field, but the list row does.
    // Pass it in so the modal can hide "Spremi kao skicu" and relabel the
    // primary button to "Spremi" for already-published entries.
    setEditingStatus(record.status);
    setModalVisible(true);
  };

  const handleModalCancel = () => {
    setModalVisible(false);
    setEditingId(null);
    setEditingStatus(null);
  };

  const handleSaved = () => {
    setModalVisible(false);
    setEditingId(null);
    setEditingStatus(null);
    loadList(filters, page);
  };

  const columns = [
    {
      title: "Marka",
      dataIndex: "makeName",
      key: "makeName",
      width: 200
    },
    {
      title: "Model",
      dataIndex: "modelName",
      key: "modelName",
      width: 200
    },
    {
      title: "Godište",
      key: "years",
      width: 140,
      render: (_: any, record: any) =>
        `${record.makeYearFrom} – ${record.makeYearTo}`
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 140,
      render: (value: number) => {
        const entry = MakeModelInfoStatusText.find(o => o.value === value);
        if (value === MakeModelInfoStatus.Published) {
          return <Tag color="green">{entry ? entry.name : "-"}</Tag>;
        }
        return <Tag>{entry ? entry.name : "-"}</Tag>;
      }
    },
    {
      title: "Akcije",
      key: "actions",
      align: "center",
      width: 100,
      render: (_: any, record: any) => (
        <Tooltip title="Uredi">
          <Button onClick={() => handleEdit(record)}>
            <Icon type="edit" />
          </Button>
        </Tooltip>
      )
    }
  ];

  return (
    <React.Fragment>
      <PageTitle title={"Info marke i modela"} />

      <MakeModelInfoFilterForm
        value={filters}
        onSubmit={handleSearch}
        onNew={handleNew}
      />

      <Table
        dataSource={items}
        // @ts-ignore
        columns={columns}
        pagination={false}
        bordered
        rowKey="id"
        className={`admin-table ${styles.table}`}
        loading={loading}
      />

      {items.length > 0 ? (
        <IndexPagination
          total={total}
          page={page}
          itemPerPage={itemPerPage}
          onPageChange={handlePageChange}
        />
      ) : null}

      <MakeModelInfoFormModal
        visible={modalVisible}
        editingId={editingId}
        editingStatus={editingStatus}
        onCancel={handleModalCancel}
        onSaved={handleSaved}
      />
    </React.Fragment>
  );
};

export default connect(
  state => ({
    // @ts-ignore
    ...state.admin.makeModelInfo
  }),
  {
    getAdminMakeModelInfoList
  }
)(ManageMakeModelInfoPage);



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageMakeModelInfoPage/ManageMakeModelInfoPage.tsx